import { render } from "./ParametrePage.vue?vue&type=template&id=f6d4f0a6"
import script from "./ParametrePage.vue?vue&type=script&lang=js"
export * from "./ParametrePage.vue?vue&type=script&lang=js"

import exportComponent from "/docker/app/vertikaljump/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__